import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";

const HeroSection = ({
  title,
  subtitle, // Optional middle line under title
  description,
  descriptionClassName = "",
  buttonText,
  buttonLink,
  background,
}) => {
  const navigate = useNavigate();
  const userContext = useContext(UserContext);
  const userData = userContext?.userData || null;

  return (
    <div className="w-full">
      {/* Full-bleed background that matches Home hero */}
      <div
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
        }}
        className="min-h-[703px]"
      >
        <div className="w-full md:max-h-[703px] items-center justify-center h-[780px] text-white flex bg-[#192029] bg-opacity-70 flex-col p-6 pt-[48px]">
          {/* Centered content area like Home hero */}
          <div className="flex flex-col gap-6 max-w-[1440px] mx-auto w-full justify-center items-start">
            <h1 className="font-medium w-full max-w-[962px] text-white text-[24px] md:text-[55px] leading-tight sm:leading-tight md:leading-tight lg:leading-[69px] tracking-[0] text-left">
              {title}
            </h1>
            {subtitle && (
              <h2
                className="text-white font-medium text-left text-[18px] md:text-[28px]"
                style={{ letterSpacing: "0.025em" }}
              >
                {subtitle}
              </h2>
            )}
            <h2
              className={`text-left ${descriptionClassName}`}
              style={{ letterSpacing: "0.025em" }}
            >
              {description}
            </h2>

            <div className="flex flex-col md:flex-row gap-4 self-start">
              {!userData && (
                <button
                  className="bg-[#3cab5c] border border-transparent hover:border-[#3c8f47] focus:border-[#3c8f47] focus:outline-none md:text-[16px] text-[14px] hover:bg-[#3c8f47] text-white md:px-6 px-4 md:py-3 py-2 rounded-xl font-medium"
                  onClick={() =>
                    buttonLink ? navigate(buttonLink) : navigate("/signup")
                  }
                >
                  {buttonText}
                </button>
              )}
              {userData && (
                <button
                  className="bg-[#3cab5c] border border-transparent hover:border-[#3c8f47] focus:border-[#3c8f47] focus:outline-none md:text-[16px] text-[14px] hover:bg-[#3c8f47] text-white md:px-6 px-4 md:py-3 py-2 rounded-xl font-medium"
                  onClick={() => navigate("/dashboard")}
                >
                  Go to Dashboard
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
